import {
  checkAnalyzingFinished,
  useDsdTaskStatus,
} from "@/components/sidebar/hooks";

/**
 * 워크북의 XBRL 분석이 아직 진행 중인지 — 시트가 하나라도 종료 상태(COMPLETED·FAILED·
 * NOT_TARGET)가 아니면 true. 판정은 `checkAnalyzingFinished` 가 하므로 ADJUSTING_ROLE 도
 * 진행 중이다.
 *
 * 현재 시트만 보는 `useIsCurrentSheetAnalyzing` 과 달리 워크북 전체를 본다. 분석이 끝나야
 * 의미가 생기는 워크북 단위 조회(태깅 안내 등)의 실행 시점을 가르는 데 쓴다. 상태를 아직
 * 모르는 동안(로딩·실패)은 false — 조회를 영영 막지 않기 위해서다. 되돌릴 수 없는 실행
 * 버튼의 잠금 조건에는 이 fail-open 계약이 맞지 않으니 `canRunWorkbookWideAction` 을 쓴다.
 */
export function useIsWorkbookAnalyzing(workbookId: string | undefined): boolean {
  const { data } = useDsdTaskStatus(workbookId);
  if (!data) return false;
  return !checkAnalyzingFinished(data);
}
